export const supportedLngs = ["en", "zh", "nl", "de", "fr", "en_GB", "zh_TW", "de_DE", "zh_CN", "nl_NL", "fr_FR", "dev"];
